import $ from 'jquery';
import BaseView from '../../core/baseView';
import { updateState } from '../../../home24/helpers/custom-elements';

export default BaseView.extend({
  events: {
    'change [name="payment[method]"]': 'onUserPaymentMethodChange'
  },

  selectors: {
    content: '.checkout-frame',
    paymentMethodRadios: '[name="payment[method]"]',
    ibanField: '#payment_installment_afterpay_iban',
    nextButton: '.acte-payment-next-btn',
    installmentAfterpayOption: '#payment_installment_afterpay'
  },

  initialize: function() {
    /*
        Setup listeners
         */
    this.listenTo(
      this.model,
      'change:paymentMethod',
      this.onPaymentMethodChange
    );

    this.updatePaymentModelFromView();
  },

  updatePaymentModelFromView: function() {
    this.model.set({
      paymentMethod: this.$(this.selectors.paymentMethodRadios)
        .filter(':checked')
        .val()
    });
  },

  onPaymentMethodChange: function() {
    this.showCurrentPaymentMethod();
    // for stickyBottomView to recalculate
    $(window).trigger('resize.stickybottom');
  },

  showCurrentPaymentMethod: function() {
    this.$(this.selectors.content).addClass('is-hidden');
    this.$(
      this.selectors.paymentMethodRadios +
        '[value="' +
        this.model.get('paymentMethod') +
        '"]'
    )
      .prop('checked', true)
      .closest('.checkout-payment-box')
      .find('.checkout-frame')
      .removeClass('is-hidden');
    updateState();
  },

  onUserPaymentMethodChange: function() {
    this.updatePaymentModelFromView();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentView.js
 **/